import {useParams} from "react-router-dom";
import {PageHeader, ProjectQuota, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import RankTable from "../components/RankTable";

/**
 * Trang tool Theo dõi thứ hạng SERP của một dự án (`/projects/:id/rank`).
 *
 * Vị trí THẬT trên Google theo Desktop/Mobile + quốc gia (DataForSEO SERP) — khác Rank
 * Tracking v1 trong GSC (vị trí trung bình, chỉ từ khoá đã hiển thị). Dùng chung cap `keyword`.
 */
function RankHome() {

	const {id} = useParams();
	const canKeyword = useCan('keyword');

	if (!canKeyword) return <div className="container">Bạn không có quyền sử dụng Theo dõi thứ hạng.</div>;

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="rank" />

			<PageHeader
				icon="fa-light fa-ranking-star"
				title="Theo dõi thứ hạng"
				subtitle="Vị trí thật trên Google theo Desktop/Mobile + quốc gia, diễn biến theo ngày, đối thủ & SERP features"
				actions={<ProjectQuota tool="rank" />}
			/>

			<RankTable projectId={id} />
		</div>
	);
}

export default RankHome;
